import React from "react";
import {TileStateRepository} from "../../../repository";
import {TileState} from "../../../model";
import {EntityFormTemplate} from "../../../component/template/EntityFormTemplate";

export const CreateTileState = () => {
    return (
        <EntityFormTemplate<TileState>
            mode={'create'}
            repository={new TileStateRepository()}
            title={{
                page: `État`,
                schema: `Ajouter un état`
            }}
            fields= {[
                { label: `Nom`, id: 'name', type: 'text' },
                { label: `Couleur`, id: 'color', type: 'color' },
                { label: `Description`, id: 'description', type: 'text' },
                { label: `Désactive la tuile`, id: 'disable', type: 'boolean' },
            ]}
        />
    )
}